import { MutableRefObject } from 'react';

import type { ScrollbarPrimaryRef } from 'app/design-system/components/Scrollbar';

import { LastAddedBet } from '../types/entries';

// ---

export const getOffsetForScroll = (
  lastAddedBet: LastAddedBet,
  scrollbars: MutableRefObject<ScrollbarPrimaryRef | null>,
): number | null => {
  if (!scrollbars.current) {
    return null;
  }
  const scrollbarsView = scrollbars.current?.contentWrapperEl;
  let element = scrollbarsView.querySelector(`[data-scroll="${lastAddedBet.betId}"]`);

  // Если не найден исход, то скорее всего собран ЭВМ и нужно скролить к нему
  if (!element) {
    element = scrollbarsView.querySelector(`[data-scroll="${lastAddedBet.matchId}"]`);

    // Если ЭВМ тоже не найден, то ничего не делаем
    if (!element) {
      console.warn('BetSlip -> element to which you need scrolling not found');
      return null;
    }
  }

  const scrollbarRect = scrollbarsView.getBoundingClientRect();
  const elementRect = element.getBoundingClientRect();

  return elementRect.top + scrollbarsView.scrollTop - scrollbarRect.top;
};
